var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"data-preloader",attrs:{"src":require("@/assets/svg/spinner-loader.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }